import {useDispatch} from 'react-redux';
import {detailsPagePushGaThunk} from '@stencil/hotels-ga/src';
import {gaConfig} from '@stencil/hotels-config';
import useIntersectionObserver from '@stencil/use-intersection-observer';

const {
  mwebDetailsPageGAEvents: {event: mwebDetailsGAEvent, category: detailsCategory},
  mwebDetailsPageGAEvents,
  DetailsGAEvents,
  foodDiningGaEvents,
} = gaConfig;

interface DetailsScrollGaMoreProps {
  featuredReviewContext?: string;
  onLoad?: Function;
}

const useDetailsScrollGa = (isMweb = false, moreProps?: DetailsScrollGaMoreProps) => {
  const dispatch = useDispatch();

  const foodIntersectionObserverOptions = {
    root: null,
    threshHold: 0.1,
  };

  const foodPropertyIntersectionObserverOptions = {
    root: null,
    threshHold: 0.1,
  };

  const featuredReviewsIntersectionObserverOptions = {
    root: null,
    threshHold: 0.1,
  };

  const [foodWatcherRef] = useIntersectionObserver(
    foodIntersectionObserverOptions,
    () => {
      dispatch(
        detailsPagePushGaThunk({
          event: isMweb ? mwebDetailsGAEvent : DetailsGAEvents.click,
          eventCategory: isMweb ? detailsCategory : foodDiningGaEvents.category.foodDiningTab,
          eventAction: foodDiningGaEvents.action.foodImpressionsClicked,
          eventLabel: 'Detail',
        }),
      );
    },
    true,
  );

  const [foodPropertyRulesWatcherRef] = useIntersectionObserver(
    foodPropertyIntersectionObserverOptions,
    () => {
      dispatch(
        detailsPagePushGaThunk({
          event: isMweb ? mwebDetailsGAEvent : DetailsGAEvents.click,
          eventCategory: foodDiningGaEvents.category.foodDiningTab,
          eventAction: foodDiningGaEvents.action.foodPropertyRules,
          eventLabel: 'Detail',
        }),
      );
    },
    true,
  );

  const [featuredReviewsWatcherRef] = useIntersectionObserver(
    featuredReviewsIntersectionObserverOptions,
    () => {
      dispatch(
        detailsPagePushGaThunk({
          event: mwebDetailsGAEvent,
          eventCategory: detailsCategory,
          eventAction: mwebDetailsPageGAEvents.action.featuredReviewImpression,
          eventLabel: moreProps?.featuredReviewContext,
        }),
      );
      if (moreProps?.onLoad && typeof moreProps?.onLoad == 'function') {
        moreProps?.onLoad();
      }
    },
    true,
  );

  return {foodWatcherRef, foodPropertyRulesWatcherRef, featuredReviewsWatcherRef};
};

export default useDetailsScrollGa;
